// extracted by mini-css-extract-plugin
module.exports = {"itemContainer":"_-_-pharmacy-src-display-feed-userPublicationFeed__itemContainer--2OP_t"};